<template>
  <div class="grid" :style="style">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Grid',
  props: {
    min: {
      type: String,
      default: '200px'
    },
    max: {
      type: String,
      default: '1fr'
    },
    gap: {
      type: String,
      default: '1em'
    }
  },
  computed: {
    style () {
      return `grid-template-columns: repeat(auto-fit, minmax(${this.min}, ${this.max})); grid-gap: ${this.gap}`
    }
  }
}
</script>

<style lang="scss" scoped>
  .grid {
    display: grid;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Grid.vue